import { useState } from "react";
import { toast } from "sonner";
import { PaperPlaneRight } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { DOMESTIC_STATES, INTERNATIONAL } from "@/data/site";

const initial = { name: "", email: "", phone: "", destination: "", travel_date: "", travelers: "", message: "" };

export default function InquiryForm({ prefillDestination = "", packageId = null, packageTitle = null, compact = false }) {
  const [form, setForm] = useState({ ...initial, destination: prefillDestination });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone) {
      toast.error("Please fill in your name, email and phone.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/inquiries", { ...form, package_id: packageId, package_title: packageTitle });
      toast.success("Thank you! Our travel expert will reach out shortly.");
      setForm({ ...initial, destination: prefillDestination });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-lg border border-brand-sand bg-brand-cream px-4 py-3 text-sm text-brand-navy outline-none transition focus:border-brand-teal focus:ring-2 focus:ring-brand-teal/30 placeholder:text-[#a3a1ba]";

  return (
    <form onSubmit={submit} data-testid="inquiry-form" className="space-y-4">
      <div className={`grid gap-4 ${compact ? "grid-cols-1" : "sm:grid-cols-2"}`}>
        <input data-testid="inquiry-name" className={inputCls} placeholder="Full name *" value={form.name} onChange={update("name")} />
        <input data-testid="inquiry-phone" className={inputCls} placeholder="Phone number *" value={form.phone} onChange={update("phone")} />
      </div>
      <input data-testid="inquiry-email" type="email" className={inputCls} placeholder="Email address *" value={form.email} onChange={update("email")} />
      <div className={`grid gap-4 ${compact ? "grid-cols-1" : "sm:grid-cols-2"}`}>
        <select data-testid="inquiry-destination" className={inputCls} value={form.destination} onChange={update("destination")}>
          <option value="">Select destination</option>
          <optgroup label="Domestic">
            {DOMESTIC_STATES.map((d) => <option key={d} value={d}>{d}</option>)}
          </optgroup>
          <optgroup label="International">
            {INTERNATIONAL.map((d) => <option key={d} value={d}>{d}</option>)}
          </optgroup>
        </select>
        <select data-testid="inquiry-travelers" className={inputCls} value={form.travelers} onChange={update("travelers")}>
          <option value="">No. of travellers</option>
          {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10+"].map((n) => <option key={n} value={n}>{n} {n === "1" ? "Traveller" : "Travellers"}</option>)}
        </select>
      </div>
      <input data-testid="inquiry-date" type="text" onFocus={(e) => (e.target.type = "date")} onBlur={(e) => { if (!e.target.value) e.target.type = "text"; }} className={inputCls} placeholder="Preferred travel date" value={form.travel_date} onChange={update("travel_date")} />
      <textarea data-testid="inquiry-message" rows={compact ? 3 : 4} className={inputCls} placeholder="Tell us about your dream trip..." value={form.message} onChange={update("message")} />
      <button
        type="submit"
        disabled={loading}
        data-testid="inquiry-submit"
        className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand-orange px-8 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-brand-orangedark disabled:opacity-60"
      >
        {loading ? "Sending..." : <>Send Enquiry <PaperPlaneRight size={18} weight="fill" /></>}
      </button>
    </form>
  );
}
